"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouter = require("react-router");
var _antd = require("antd");
var _icon = _interopRequireDefault(require("../icon/icon.js"));
require("./turing-header.css");
var _reactRouterDom = require("react-router-dom");
var _horizontalMenu = _interopRequireDefault(require("../../uiux/horizontal-menu/horizontal-menu"));
var _button = _interopRequireDefault(require("../button/button.js"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var _wr = function _wr(type) {
  var orig = window.history[type];
  return function () {
    var rv = orig.apply(this, arguments);
    var e = new Event(type);
    e.arguments = arguments;
    window.dispatchEvent(e);
    return rv;
  };
};
window.history.pushState = _wr("pushState");
window.history.popstate = _wr("popstate");
window.history.replaceState = _wr("replaceState");

// Search in structure array functions
function findPath(structure) {
  return structure.path === window.location.pathname;
}
function findGroup(structure) {
  return structure.group;
}
function findSubMenu(structure) {
  return structure.subMenu;
}
function findFeatured(structure) {
  return structure.featured;
}
function findPathRegexp(subItems) {
  if (!subItems.pathRegexp) return false;
  var isValid = true;
  try {
    new RegExp(subItems.pathRegexp);
  } catch (e) {
    isValid = false;
  }
  if (!isValid) return false;
  return window.location.pathname.match(subItems.pathRegexp);
}
function findPathParams(subItems) {
  if (!subItems.path) return false;
  var pathParams = "^" + subItems.path.replace(/\//gi, "\\/").replace(/:[0-9a-z_.%@-]+/gi, '[0-9a-z_.%-]+') + "$";
  //  console.log("HEADER findPathParams pathParams: ", pathParams)
  var isValid = true;
  try {
    pathParams = new RegExp(pathParams, 'gi');
  } catch (e) {
    isValid = false;
  }
  if (!isValid) return false;
  return window.location.pathname.match(pathParams);
}
var TuringHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(TuringHeader, _React$Component);
  var _super = _createSuper(TuringHeader);
  function TuringHeader(props) {
    var _this;
    _classCallCheck(this, TuringHeader);
    _this = _super.call(this, props);
    _this.rerender = _this.rerender.bind(_assertThisInitialized(_this));
    window.addEventListener("replaceState", function (e) {
      return _this.rerender(e);
    });
    window.addEventListener("popstate", function (e) {
      return _this.rerender(e);
    });
    window.addEventListener("pushState", function (e) {
      return _this.rerender(e);
    });
    var blankFunc = function blankFunc() {};
    _this.backButtonHandler = typeof _this.props.backButtonHandler === "function" ? _this.props.backButtonHandler : blankFunc;
    return _this;
  }
  _createClass(TuringHeader, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;
      window.removeEventListener("replaceState", function (e) {
        return _this2.rerender(e);
      });
      window.removeEventListener("popstate", function (e) {
        return _this2.rerender(e);
      });
      window.removeEventListener("pushState", function (e) {
        return _this2.rerender(e);
      });
    }
    // rerender on path change
  }, {
    key: "rerender",
    value: function rerender(e) {
      e.preventDefault();
      e.stopPropagation();
      this.setState({});
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      //        console.log('TuringHeader render this.props: ', this.props)
      var submenu = false;
      var parent = false;
      var parentTitle = false;
      var parentPath = false;
      var backButton = this.props.backButton;
      var title = false;
      var icon = false;
      var featured = this.props.featuredFunctions;
      var context = this.props.contextPanel;
      var foundPath = this.props.menuItems.filter(findPath);
      var foundGroup = this.props.menuItems.filter(findGroup);
      var foundSubMenu = this.props.menuItems.filter(findSubMenu);
      var foundFeatured = this.props.menuItems.filter(findFeatured);
      var i, ii;
      if (foundPath[0]) {
        //if path found in 1-st level
        title = foundPath[0].fullTitle || foundPath[0].title;
        featured = foundPath[0].featured;
        if (foundPath[0].titleIcon) icon = foundPath[0].icon;
        if (foundPath[0].subMenu) {
          submenu = foundPath[0].subMenu;
        }
      }
      if (!title) {
        // parsing subMenus at 1-st level
        ii = 0;
        foundSubMenu.forEach(function (subMenu) {
          var foundPathInSubMenu = subMenu.subMenu.filter(findPath);
          if (foundPathInSubMenu[0]) {
            parentTitle = foundSubMenu[ii].title;
            parentPath = foundSubMenu[ii].path;
            title = foundPathInSubMenu[0].fullTitle || foundPathInSubMenu[0].title;
            featured = foundPathInSubMenu[0].featured;
            submenu = subMenu.subMenu;
            if (foundPathInSubMenu[0].titleIcon) icon = foundPathInSubMenu[0].icon;
          }
          ii++;
        });
      }
      if (!title) {
        i = 0;
        foundFeatured.forEach(function (featuredItem) {
          var foundPathInFeatured = featuredItem.featured.filter(findPath);
          if (foundPathInFeatured[0]) {
            parentTitle = foundFeatured[i].title;
            parentPath = foundFeatured[i].path;
            title = foundPathInFeatured[0].fullTitle || foundPathInFeatured[0].title;
            featured = foundPathInFeatured[0].featured;
            submenu = featuredItem.subMenu;
            if (foundPathInFeatured[0].titleIcon) icon = foundPathInFeatured[0].icon;
          }
          i++;
        });
      }
      if (!title) {
        i = 0;
        var foundRelated = this.props.menuItems.filter(function (e) {
          return e.related;
        });
        foundRelated.forEach(function (itemHasRelated) {
          var foundPathRegexpInRelated = itemHasRelated.related.filter(findPathRegexp);
          var foundPathInRelated = itemHasRelated.related.filter(findPathParams);
          var foundPathItem = foundPathRegexpInRelated.concat(foundPathInRelated);
          if (foundPathItem[0]) {
            parentTitle = foundRelated[i].title;
            parentPath = foundRelated[i].path;
            title = foundPathItem[0].fullTitle || foundPathItem[0].title;
            featured = foundPathItem[0].featured;
            if (foundPathItem[0].titleIcon) icon = foundPathItem[0].icon;
          }
          i++;
        });
      }
      if (!title) {
        // parsing groups
        foundGroup.forEach(function (group) {
          var foundPathInGroup = group.group.filter(findPath);
          if (foundPathInGroup[0]) {
            // if path found in group
            title = foundPathInGroup[0].fullTitle || foundPathInGroup[0].title;
            featured = foundPathInGroup[0].featured;
            if (foundPathInGroup[0].titleIcon) icon = foundPathInGroup[0].icon;
            if (foundPathInGroup[0].subMenu) submenu = foundPathInGroup[0].subMenu;
          } else {
            // parsing subMenus in groups
            var foundSubMenuInGroup = group.group.filter(findSubMenu);
            i = 0;
            foundSubMenuInGroup.forEach(function (subMenu) {
              var foundPathInSubMenu = subMenu.subMenu.filter(findPath);
              if (foundPathInSubMenu[0]) {
                parentTitle = foundSubMenuInGroup[i].title;
                parentPath = foundSubMenuInGroup[i].path;
                title = foundPathInSubMenu[0].fullTitle || foundPathInSubMenu[0].title;
                featured = foundPathInSubMenu[0].featured;
                if (foundPathInSubMenu[0].titleIcon) icon = foundPathInSubMenu[0].icon;
                submenu = foundSubMenuInGroup[i].subMenu;
              }
              i++;
            });
            if (!title) {
              var foundFeaturedInGroup = group.group.filter(findFeatured);
              var iii = 0;
              foundFeaturedInGroup.forEach(function (featuredItem) {
                var foundPathInFeatured = featuredItem.featured.filter(findPath);
                if (foundPathInFeatured[0]) {
                  parentTitle = foundFeaturedInGroup[iii].title;
                  parentPath = foundFeaturedInGroup[iii].path;
                  title = foundPathInFeatured[0].fullTitle || foundPathInFeatured[0].title;
                  featured = foundPathInFeatured[0].featured;
                  if (foundPathInFeatured[0].titleIcon) icon = foundPathInFeatured[0].icon;
                  submenu = foundFeaturedInGroup[iii].subMenu;
                }
                iii++;
              });
            }
            if (!title) {
              ii = 0;
              var foundRelatedInGroup = group.group.filter(function (e) {
                return e.related;
              });
              foundRelatedInGroup.forEach(function (itemHasRelated) {
                var foundPathRegexpInRelated = itemHasRelated.related.filter(findPathRegexp);
                var foundPathInRelated = itemHasRelated.related.filter(findPathParams);
                var foundPathItem = foundPathRegexpInRelated.concat(foundPathInRelated);
                if (foundPathItem[0]) {
                  parentTitle = foundRelatedInGroup[ii].title;
                  parentPath = foundRelatedInGroup[ii].path;
                  title = foundPathItem[0].fullTitle || foundPathItem[0].title;
                  featured = foundPathItem[0].featured;
                  if (foundPathItem[0].titleIcon) icon = foundPathItem[0].icon;
                }
                ii++;
              });
            }
          }
        });
      }
      if (!title) {
        title = this.props.title;
      }
      if (featured) {
        //      console.log('HEADER FEATURED:', featured)
        var featuredArray = featured;
        featured = [];
        var _i = 0;
        featuredArray.forEach(function (fItem) {
          featured.push( /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              padding: "2px"
            },
            key: 'featured_div_' + _i
          }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
            to: fItem.path.replace(/([%])/gi, encodeURIComponent("$1")),
            key: 'featured_link' + _i
          }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
            label: fItem.title,
            icon: fItem.icon,
            primary: true,
            keyValue: 'featured_button_' + _i
          }))));
          _i++;
        });
        featured = /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: "flex",
            flexWrap: 'wrap'
          },
          key: 'featured'
        }, featured);
      }
      var backButtonOnClick;
      if (parentTitle && backButton) {
        backButtonOnClick = function backButtonOnClick(e) {
          e.stopPropagation();
          e.preventDefault();
          _this3.backButtonHandler(e);
          _this3.props.history.goBack();
        };
        parentTitle = "Back";
      } else if (parentTitle) {
        backButtonOnClick = function backButtonOnClick(e) {
          _this3.backButtonHandler(e);
        };
      }
      if (parentTitle) parent = /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        to: parentPath.replace(/([%])/gi, encodeURIComponent("$1")),
        className: "back-link blackLink",
        key: 'parent_link_icon',
        onClick: function onClick(e) {
          return backButtonOnClick(e);
        },
        state: this.props.backButtonState
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        img: "arrow_back",
        className: "material-icons-round"
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "label"
      }, parentTitle));
      var header = [/*#__PURE__*/_react["default"].createElement("div", {
        className: "back-button",
        key: "back-button"
      }, parent), /*#__PURE__*/_react["default"].createElement("div", {
        className: "featured-functions",
        key: "featured-functions"
      }, featured), /*#__PURE__*/_react["default"].createElement("div", {
        className: "title",
        key: "title"
      }, icon ? /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        className: "material-icons-round"
      }, icon) : "", /*#__PURE__*/_react["default"].createElement("h2", null, title))];
      if (this.props.contextPanel) header.push( /*#__PURE__*/_react["default"].createElement("div", {
        className: "context",
        key: "context"
      }, this.props.contextPanel));
      if (submenu) {
        header.push( /*#__PURE__*/_react["default"].createElement("div", {
          className: "horizontal-navigation",
          key: "horizontal-navigation"
        }, /*#__PURE__*/_react["default"].createElement(_horizontalMenu["default"], {
          key: "HeaderHorizontalMenu",
          items: submenu
        })));
      }
      return header;
    }
  }]);
  return TuringHeader;
}(_react["default"].Component);
var _default = exports["default"] = (0, _reactRouter.withRouter)(TuringHeader);